import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import { SyntheticEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type IProps = Omit<FormControlLabelProps, 'control'>

export interface RHFSwitchProps extends IProps {
  name: string
  onChangeCallback?: (event: SyntheticEvent) => any
}

export function RHFSwitch({ name, disabled, onChangeCallback, label = '', ...other }: RHFSwitchProps) {
  const { control } = useFormContext()

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, ref, ...field } }) => (
            <Switch
              {...field}
              inputRef={ref}
              disabled={disabled}
              checked={field.value}
              onChange={e => {
                onChange(e)
                onChangeCallback?.(e)
              }}
            />
          )}
        />
      }
      sx={other.sx ?? { mx: 0, width: 1, justifyContent: 'space-between' }}
      labelPlacement={other?.labelPlacement ?? 'start'}
      label={label ?? ''}
      {...other}
    />
  )
}
